import { N05_01 } from "./N05_01";

export const N05 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "stacked",
    colorTheme: "colorTheme1",
    title: "Stocks Trend Based On Number Of Branches Covered",
    orientation: "horizontal",
    xAxis: "",
    yAxis: "",
    binding: {
      data: {
        series: [
          {
            name: "OOS",
            value: "OutOfStock",
          },
          {
            name: "Not Carried",
            value: "NotCarried",
          },
          {
            name: "Carried",
            value: "Carried",
          },
          {
            name: "For Deletion",
            value: "ForDeletion",
          },
          {
            name: "Deleted",
            value: "Deleted",
          },
          {
            name: "Available",
            value: "Available",
          },
        ],
        title: "ItemName",
        endpoint: "N05",
        parameters: [
            { key: "CycleCode", value: "CP1" },
            { key: "CycleYear", value: "2026" },
        ],
      },
      context: {
        point: {
          onClick: N05_01,
        },
      },
    },
  },
};
